module.exports = __webpack_public_path__ + "img/symbol_1.5b30c6cb.png";